import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {t} from 'i18next';

class TaxonomyFilter extends React.Component {

    static propTypes = {
        label: PropTypes.string.isRequired,
        terms: PropTypes.array.isRequired,
        checked: PropTypes.array,
        expanded: PropTypes.bool,
        onChange: PropTypes.func,
        onToggle: PropTypes.func,
        toggleAllTerms: PropTypes.func,
        maxTermsOnFirstLevel: PropTypes.number,
        showAllTerms: PropTypes.bool,
    };

    static defaultProps = {
        label: null,
        terms: null,
        checked: [],
        expanded: false,
        onChange: () => {},
        onToggle: () => {},
        toggleAllTerms: () => {},
        maxTermsOnFirstLevel: null,
        showAllTerms: false,
    };

    renderTerms( terms, level = 1 ) {
        const cssClass = classNames(['taxonomy-terms-list','level-' + level]);
        return <div className={cssClass}>
            {terms.map( ( term, i ) => {
                if ( level === 1 && this.props.maxTermsOnFirstLevel && i >= this.props.maxTermsOnFirstLevel && ! this.props.showAllTerms ) {
                    return ( i === this.props.maxTermsOnFirstLevel ) ? <button type="button" className="hide-show-more" key="show-more" onClick={e => this.props.toggleAllTerms(true)}>{t('+ %d more',{postProcess: 'sprintf', sprintf:[ terms.length - i ]})}</button> : null;
                }
                const isChecked = this.props.checked.indexOf(term.term_id) !== -1;
                return <div className="taxonomy-terms-list__checkbox" key={term.term_id}>
                        <input id={term.name+'_'+term.term_id}
                               type="checkbox"
                               checked={isChecked}
                               value={term.term_id}
                               onChange={e => this.props.onChange(e)}
                        />
                    <label htmlFor={term.name+'_'+term.term_id}>
                        {term.name}
                    </label>
                    { ( term.children.length && ( isChecked || this.hasChildrenChecked( term ) ) ) ? this.renderTerms( term.children, level + 1 ) : null }
                </div>
            })}
            { ( this.props.showAllTerms && level === 1 ) ? <button type="button" className="hide-show-more" onClick={e => this.props.toggleAllTerms(false)}>{t('Show Less')}</button> : null}
        </div>;
    }

    hasChildrenChecked( term ) {

        let hasChildrenChecked = false;
        term.children.forEach( child => {
            hasChildrenChecked = hasChildrenChecked || ( this.props.checked.indexOf( child.term_id ) !== -1 ) || this.hasChildrenChecked( child );
        });
        return hasChildrenChecked;
    }

    countChecked( terms ) {
        let count = 0;
        terms.forEach( term => {
            if ( this.props.checked.indexOf(term.term_id) !== -1 ) {
                count++;
            }
            if ( term.children.length ) {
                count += this.countChecked( term.children );
            }
        });
        return count;
    }

    render() {
        const { label, terms, expanded, onToggle } = this.props;
        if ( ! terms || ! terms.length ) {
            return null;
        }
        const cssClass = classNames({
            'taxonomy-filter': true,
            'expanded': expanded
        });
        const count = this.countChecked( terms );
        return <div className={cssClass}>
            <button className="taxonomy-filter__label" onClick={e => onToggle(e)}>{label} { count ? <span className="badge">{count}</span> : null }</button>
            {expanded && <div className="taxonomy-terms">
                {this.renderTerms( terms )}
            </div>}
        </div>;
    }
}

export default TaxonomyFilter;



// WEBPACK FOOTER //
// ./src/components/TaxonomyFilter/TaxonomyFilter.js